import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Button,
  Typography,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Grid from "@mui/material/Grid2";
import download_btn from "../../Admin/assets/icons/download_button.svg";
import Image from "../../Utils/getImage";
import instance from "../../Utils/api";
import { toast } from "react-toastify";
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from "dayjs";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const ViewConsultationPopup = ({
  openviewDialog,
  setopenviewDialog,
  customerdata,
  openDialog,
  setOpenDialog,
  edit,
  download,
  editData,
  handleConsultationData
}) => {
  const [selectedPerson, setSelectedPerson] = useState('')
  const [employeeData, setEmployeeData] = useState();
  const [bookData, setBookData] = useState({
    consultation_type: "",
    consultation_date: ""
  });
  const [status, setStatus] = useState("");


  //handle close
  const handleClose = () => {
    setopenviewDialog(false);
    setOpenDialog(false);
    setSelectedPerson('');
    setStatus("");
    setBookData({ consultation_type: "", consultation_date: "" })
  };

  const EmployeeData = async () => {
    try {
      const response = await instance.get('/Admin/getAdmins');
      setEmployeeData(response.data.data);
    } catch (error) {
      console.log(error);
    }
  }
  useEffect(() => {
    EmployeeData();
  }, [])

  const handleassign = async (id) => {
    if (!selectedPerson) {
      return toast.error('Please Assign a Person')
    }
    try {
      const response = await instance.patch('/Consultation/assignConsultation', {
        consultation_id: customerdata._id,
        admin_id: selectedPerson
      })
      // console.log(response);
      if (response.data.success === true) {
        toast.success(response.data.message);
        handleConsultationData();
        handleClose();
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  }

  const handleBookConsultation = async (id) => {
    if (!bookData.consultation_type) {
      return toast.error('Please select a consultation type')
    } else if (!bookData.consultation_date) {
      return toast.error('Please select a consultation date')
    }
    try {
      const response = await instance.patch('/Consultation/bookConsultation', {
        consultation_id: id,
        consultation_type: bookData.consultation_type,
        consultation_date: bookData.consultation_date
      });
      if (response.data.success === true) {
        toast.success(response.data.message);
        handleConsultationData();
        handleClose();
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.message);
    }
  }

  const handleStatus = async (id) => {
    try {
      const response = await instance.patch('/Consultation/finishConsultation', {
        consultation_id: id,
        status: status
      })
      if (response.data.success === true) {
        toast.success(response.data.message);
        handleConsultationData();
        handleClose();
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.message);
    }
  }
  // console.log(customerdata);

  return (
    <React.Fragment>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={edit ? openDialog : openviewDialog}
        className="admin-admins"
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          {"consultation Info"}
          <Typography>
            {"In person booking info"}
          </Typography>
          <div className="consultation-popup"></div>
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <section className="add-consultantation">
            <div className="add-employee-title">
              <Typography>
                {"consultation Person info"}
              </Typography>
            </div>
            <Grid
              container
              spacing={2}
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-start",
              }}
            >
              <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 3 }}>
                <div className="add_emloyee-upload-file">
                  <Image src={customerdata?.Customer?.profile_pic} alt="upload_image" width={220} height={171} />
                  <Typography variant="h5">
                    {customerdata?.Customer?.name ? customerdata?.Customer?.name : "----"}
                  </Typography>
                </div>
              </Grid>
              <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 9 }}>
                <div className="add_emloyee-content">
                  <div className="add_emloyee-content-text">
                    <Typography variant="h5">
                      {customerdata ? "Order type" : "Order type"}
                    </Typography>
                    <Typography>
                      <span
                        style={{
                          backgroundColor: (() => {
                            switch (customerdata?.consultation_type) {
                              case "In Person":
                                return "#FF9800";
                              case "Online":
                                return "#2196F3";
                              default:
                                return "#E0E0E0";
                            }
                          })(),
                          color: (() => {
                            switch (customerdata?.consultation_type) {
                              case "In Person":
                                return "#fff";
                              case "Online":
                                return "#fff";
                              default:
                                return "#757575";
                            }
                          })(),
                          padding: "5px 10px",
                          borderRadius: "5px",
                          textAlign: "center",
                        }}
                      >
                        {customerdata?.consultation_type ? customerdata?.consultation_type : "----"}
                      </span>
                    </Typography>
                  </div>
                  <div className="add_emloyee-content-text">
                    <Typography variant="h5">
                      {customerdata ? "Booking date" : "Booking date"}
                    </Typography>
                    <Typography>
                      {customerdata?.consultation_date ? new Date(customerdata?.consultation_date).toLocaleDateString() : "----"}
                    </Typography>
                  </div>
                  <div className="add_emloyee-content-text">
                    <Typography variant="h5">
                      {customerdata ? "Status" : "Status"}
                    </Typography>
                    <Typography>
                      <span
                        style={{
                          background: customerdata?.status === "Booked" ? "#546E7A" : "#000",
                          color: customerdata?.status === "Booked" ? "#fff" : "#fff",
                          padding: "5px 10px",
                          borderRadius: "5px",
                          textAlign: "center"
                        }}
                      >
                        {customerdata?.status ? customerdata?.status : "----"}
                      </span>
                    </Typography>
                  </div>
                  <div className="add_emloyee-content-text">
                    <Typography variant="h5">
                      {"Mobile number"}
                    </Typography>
                    <Typography>
                      {customerdata?.Customer?.mobile ? customerdata?.Customer?.mobile : "----"}
                    </Typography>
                  </div>
                </div>
                <div className="add_emloyee-content" style={{ marginTop: 20 }}>
                  <div className="consultation-form">
                    <div className="add_emloyee-content-text">
                      <Typography variant="h5">Address</Typography>
                      {/* <Typography>
                      {customerdata
                        ? customerdata.customer.address.split(',').map((part,index) => (
                        <Typography key={index}>{part.trim()}</Typography>))
                        : "10-2-289/34, Shanti Nagar Hyderabad, Telangana 500028".split(',').map((part,index) => (
                            <Typography key={index}>{part.trim()}</Typography>
                        ))}
                    </Typography> */}
                      <Typography>{customerdata?.Customer?.location ? customerdata?.Customer?.location : "----"}</Typography>
                    </div>
                    <div className="add_emloyee-content-text">
                      <div className="admin-textfiled">
                        {!customerdata?.Admin && editData === true ?
                          <FormControl fullWidth>
                            <Typography variant="h5">Add Assign Person</Typography>
                            <Select
                              value={selectedPerson}
                              onChange={(e) => setSelectedPerson(e.target.value)}
                              displayEmpty
                            >
                              <MenuItem value="" disabled>
                                <em>Choose a person</em>
                              </MenuItem>
                              {employeeData ? employeeData?.map((data) => (
                                <MenuItem value={data._id}>{data.name}</MenuItem>
                              )) : null}
                            </Select>
                          </FormControl> :
                          <>
                            <Typography variant="h5">Assigned Person Name</Typography>
                            <Typography>{customerdata?.Admin?.name ? customerdata?.Admin?.name : '----'}</Typography>
                          </>
                        }
                      </div>
                    </div>
                    <div className="add_emloyee-content-text">
                      <div className="admin-textfiled">
                        {editData === true && customerdata?.Admin && !customerdata?.consultation_date ?
                          <>
                            <FormControl fullWidth>
                              <Typography variant="h5">Consultation Type</Typography>
                              <Select
                                value={bookData?.consultation_type}
                                onChange={(e) => setBookData({ ...bookData, "consultation_type": e.target.value })}
                                displayEmpty
                              >
                                <MenuItem value="" disabled>
                                  <em>Choose Type</em>
                                </MenuItem>
                                <MenuItem value="In Person">{"In Person"}</MenuItem>
                                <MenuItem value="Online">{"Online"}</MenuItem>
                              </Select>
                            </FormControl>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DemoContainer components={['DatePicker']}>
                                <DatePicker label="Booking Date" minDate={dayjs()} onChange={(newDate) => setBookData({ ...bookData, "consultation_date": newDate })} />
                              </DemoContainer>
                            </LocalizationProvider>
                          </>
                          : null}
                      </div>
                    </div>
                    <div className="add_emloyee-content-text">
                      <div className="admin-textfiled">
                        {editData === true && customerdata?.Admin && customerdata?.consultation_date && customerdata?.consultation_type && customerdata?.status !== "Completed" && customerdata?.status !== "Canceled" ?
                          <>
                            <FormControl fullWidth>
                              <Typography variant="h5">Status</Typography>
                              <Select
                                value={status}
                                onChange={(e) => setStatus(e.target.value)}
                                displayEmpty
                              >
                                <MenuItem value="" disabled>
                                  <em>Choose Status</em>
                                </MenuItem>
                                <MenuItem value="Completed">{"Completed"}</MenuItem>
                                <MenuItem value="Canceled">{"Canceled"}</MenuItem>
                              </Select>
                            </FormControl>
                          </>
                          : null}
                      </div>
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
          </section>
          {customerdata?.Admin ? <div className="consultation-popup"></div> : null}
          {customerdata?.Admin && editData === false ? (
            <section className="add-consultantation">
              <div className="add-employee-title">
                <Typography>
                  {"Assigned Person info"}
                </Typography>
              </div>
              <Grid
                container
                spacing={2}
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                }}
              >
                <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 3 }}>
                  <div className="add_emloyee-upload-file">
                    <Image src={customerdata?.Admin?.profile_pic} alt="upload_image" width={220} height={171} />
                    <Typography variant="h5">
                      {customerdata?.Admin?.name}
                    </Typography>
                  </div>
                </Grid>
                <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 8 }}>
                  <div className="add_emloyee-content">
                    <div className="add_emloyee-content-text">
                      <Typography variant="h5">
                        {"Mobile number"}
                      </Typography>
                      <Typography>
                        {customerdata?.Admin?.mobile}
                      </Typography>
                    </div>
                    <div className="add_emloyee-content-text">
                      <Typography variant="h5">
                        {customerdata ? "Designation" : "Designation"}
                      </Typography>
                      <Typography>
                        {customerdata?.Admin?.role}
                      </Typography>
                    </div>
                    <div className="add_emloyee-content-text">
                      <Typography variant="h5">
                        {"Email"}
                      </Typography>
                      <Typography>
                        {customerdata?.Admin?.email}
                      </Typography>
                    </div>
                  </div>
                  <div
                    className="add_emloyee-content"
                    style={{ marginTop: 20 }}
                  >
                    <div className="add_emloyee-content-text">
                      <Typography variant="h5">Address</Typography>
                      <Typography>
                        {/* {customerdata
                          ? customerdata?.customer?.address.split(',').map((part, index) => (
                            <Typography key={index}>{part.trim()}</Typography>))
                          : "10-2-289/34, Shanti Nagar Hyderabad, Telangana 500028".split(',').map((part, index) => (
                            <Typography>{part.trim()}</Typography>
                          ))} */}
                        {customerdata?.Admin?.address}
                      </Typography>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </section>
          ) : null}
        </DialogContent>
        <DialogActions>
          <Button className="cancel-btn" onClick={handleClose}>
            Cancel
          </Button>
          {download ? null : <Button className="download-btn">
            Download <img src={download_btn} alt="download" />
          </Button>}
          {editData === true && !customerdata?.Admin ?
            <Button onClick={handleassign} className="add-btn">
              {'Assign'}
            </Button> : null}
          {editData === true && customerdata?.Admin && !customerdata?.consultation_date ? (
            <Button onClick={() => handleBookConsultation(customerdata?._id)} className="add-btn">
              {"Book"}
            </Button>
          ) : null}
          {editData === true && customerdata?.Admin && customerdata?.consultation_date && customerdata?.consultation_type && customerdata.status !== "Completed" && customerdata?.status !== "Canceled" ? (
            <Button onClick={() => handleStatus(customerdata?._id)} className="add-btn">
              {"Update"}
            </Button>
          ) : null}
        </DialogActions>
      </BootstrapDialog >
    </React.Fragment >
  );
};

export default ViewConsultationPopup;

